import React, {useCallback, useEffect, useState} from "react";
import {Link, useHistory, useParams} from "react-router-dom";
import {trainingsEnroll, getTrainingsDetail} from "../../service";
import {TrainingsData} from "../types";
import ImageBox from "../../components/Image";
import MakePhoneCall from "../../components/makePhoneCall";
import usePhones from "../../routers/usePhones";
import {useModal} from "../../components/modal";
import {useLoading} from "../../components/loading/LoadingProvider";
import useUserInfo from "../../routers/useUserInfo";

interface ActMatch {
    actId: string,
}

const ActDetail = () => {

    const {actId} = useParams<ActMatch>();
    const [detail, setDetail] = useState<TrainingsData>()
    const userData = useUserInfo(false)
    const [cover,setCover] = useState<boolean>(false)
    const modal = useModal()
    const loading = useLoading()
    const phones = usePhones()
    const { push,goBack } = useHistory()

    useEffect(() => {
        getTrainingsDetail({
            activityId: actId
        }).then(res => {
            if (res.code === 1) {
                setDetail(res.data)
            }else{
                loading.showError(res.msg,() => {
                    goBack()
                })
            }
        })
    }, [actId])

    const SubmitHandle = useCallback(() => {
        if (userData) {
            trainingsEnroll({
                userId: userData.id,
                trainingId: actId
            }).then(res => {
                if (res.code === 1) {
                    modal.show({
                        content:'你已报名成功，请在 [个人中心-> 线下课程] 下查看',
                        success:(res) => {
                            if(res.confirm){
                                push('/user')
                            }
                        }
                    })
                }else{
                    if(res.msg.search('重复') !== -1){
                        modal.show({
                            content:'您已报名 请前往【个人中心】-【线下课程】查看',
                            confirmText:'线下课程',
                            success:(res) => {
                                if(res.confirm){
                                    push('/user/offline')
                                }
                            }
                        })
                    }else{
                        loading.showError(res.msg)
                    }
                }
            })
        } else {
            modal.show({
                content:'此操作需要登录!',
                confirmText:'去登录',
                success:(res) => {
                    if(res.confirm){
                        push('/login')
                    }
                }
            })
        }

    }, [actId])

    return <div className="act-detail sss">
        <div className="f-t">
            <ImageBox src={ detail?.coverUrl } height={ 130 }/>
            <div className="top">
                <h3>{ detail?.trainTitle }</h3>
                <p className="d"> <span className='iconfont'>&#xe616;</span> 活动时间：{ detail?.startTime } ~ { detail?.endTime }</p>
                <p className="d"> <span className="iconfont">&#xe728;</span> 活动地点：{ detail?.address }</p>
                <div className="rules">
                    <p>{ detail?.threshold }
                    </p>
                </div>
            </div>
        </div>
        <div className="space"/>
        <div className="content">
            <h2 className="d-title"><span className='iconfont'>&#xe64f;</span> 活动详情</h2>
            <div className="text" dangerouslySetInnerHTML={{ __html:detail ? detail.trainContent : '' }}/>
        </div>
        {
            detail && <div className="fixed-space" style={{height: '1rem'}}>
                <div className="common-fixed">
                    <div className="common-btn" onClick={() => setCover(true)}>
                        <p className="iconfont">&#xe62e;</p>
                        <p>我要咨询</p>
                    </div>
                    <div onClick={ SubmitHandle }  className="common-btn">立即报名</div>
                </div>
            </div>
        }
        <MakePhoneCall show={ cover } telephone={ phones[4] } onClose={() => setCover(false)}/>
    </div>

}

export default ActDetail;
